<template>
  <div>
    <div
      :class="{
        'd-flex justify-content-center mb-3 loading-spinner-wrapper': loading,
        'd-none': !loading
      }"
      class=""
    >
      <b-spinner variant="primary" label="Loading..."></b-spinner>
    </div>
    <div v-show="!loading">
      <!------------------
            HEADER
    -------------------->
      <div class="bg-white p-2 pt-3 pb-3 d-flex align-items-top page-header" style="padding-bottom: 0">
        <div class="col">
          <div>
            <h4>{{ record ? record.Ordinal + ' ' + record.DisplayName : '' }}</h4>
          </div>
          <div class="text-uppercase text-secondary"><small>Vergabeeinheit budgetrieren</small></div>
        </div>
        <div class="col-auto">
          <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->

          <b-button size="sm" variant="light" class="ml-2">
            <b-icon @click="refreshFormData" icon="arrow-repeat" variant="dark" class=""></b-icon>
          </b-button>
          <b-button size="sm" variant="white" class="ml-2" @click="$router.back()">
            <b-icon icon="x" variant="dark" class=""></b-icon>
          </b-button>
        </div>
      </div>
      <div class="bg-white px-4 mt-0 pt-0" style="border-bottom: 1px solid #dee2e6;">
        <hr class="m-0" />
        <b-form ref="veForm" style=" max-width:1000px">
          <div class="row mt-3 pb-0">
            <div class="col col-3">
              <label class="text-muted d-block mb-1"><small>Gesamtbudget</small></label>
              <div class="bg-light p-1">
                {{ formatCurrency(parseFloat(record.BudgetSaldo)) }}
              </div>
            </div>
            <div class="col col-3">
              <label class="text-muted d-block mb-1"><small>Nachtragsrückstellung</small></label>
              <b-input-group
                size="sm"
                prepend="%"
                @change="updateSingleField"
                v-if="$root.$user.isPlaner || $root.$user.isAdmin"
              >
                <b-input
                  @keydown.enter.prevent.stop
                  debounce="500"
                  type="number"
                  min="0"
                  max="99"
                  v-model="record.NTR"
                  size="sm"
                />
              </b-input-group>
              <div class="bg-light p-1" v-if="!$root.$user.isPlaner && !$root.$user.isAdmin">
                {{ $utils.numberWithMaxFrictionsDE(record.NTR, 1) }} %
              </div>
            </div>
            <div class="col col-3">
              <label class="text-muted d-block mb-1"><small>Zielvergabe</small></label>
              <div class="bg-light p-1">
                {{
                  $utils.numberToCurrency(
                    parseFloat(record.BudgetSaldo) * (1 - parseFloat(record.NTR / 100)),
                    settingsStore.settings['Centbetraege']
                  )
                }}
              </div>
            </div>
            <div class="col col-3">
              <label class="text-muted d-block mb-1"><small>Status</small></label>
              <div class="bg-light p-1">{{ record.ProcessStatus }}</div>
            </div>
          </div>
          <div class="row mt-0 pb-4">
            <div class="col col-3" v-show="settingsStore.settings['KGR_Selections_Active'] == 'true'">
              <label class="text-muted d-block mb-1"><small>Kostengruppe</small></label>
              {{ record.KGR ? (record.KGR == '' ? '(leer)' : record.KGR) : '(leer)' }}
            </div>
            <div class="col col-3" v-show="settingsStore.settings['Responsible_Selections_Active'] == 'true'">
              <label class="text-muted d-block mb-1"><small>Verantwortlich</small></label>
              {{ record.Responsible ? (record.Responsible == '' ? '(leer)' : record.Responsible) : '(leer)' }}
            </div>
            <div class="col col-3" v-show="settingsStore.settings['FA1_Active'] == 'true'">
              <label class="text-muted d-block mb-1">
                <small>{{ settingsStore.settings['FA1'] }}</small>
              </label>
              {{ record.FA1 ? (record.FA1 == '' ? '(leer)' : record.FA1) : '(leer)' }}
            </div>
            <div class="col col-3" v-show="settingsStore.settings['FA2_Active'] == 'true'">
              <label class="text-muted d-block mb-1">
                <small>{{ settingsStore.settings['FA2'] }}</small>
              </label>
              {{ record.FA2 ? (record.FA2 == '' ? '(leer)' : record.FA2) : '(leer)' }}
            </div>
          </div>
        </b-form>
      </div>
      <div class="mt-3">
        <b-nav tabs class="pl-3">
          <b-nav-item :to="{ name: 'VE Budget', params: $router.currentRoute.params }">Budget</b-nav-item>
          <b-nav-item disabled>Preiserfassung</b-nav-item>
          <b-nav-item :to="{ name: 'VE Aufträge', params: $router.currentRoute.params }">Auftrag</b-nav-item>
          <b-nav-item disabled>Nachträge</b-nav-item>
          <b-nav-item disabled>Rechnungen</b-nav-item>
          <b-nav-item disabled>Risikobewertung</b-nav-item>
          <b-nav-item disabled>Prognosen</b-nav-item>
        </b-nav>
      </div>
      <div class="main-canvas bg-white" style="height: calc(100vh - 265px)">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import settingsStore from '@/store/Settings';
import allocationUnitsService from '@/service/AllocationUnitsService';
import AppState from '@/store/App.js';

export default {
  data() {
    return {
      record: {
        DisplayName: '',
        NTR: 0.0
      },
      settingsStore,
      loading: true
    };
  },
  methods: {
    refreshFormData() {
      allocationUnitsService
        .getAllocationUnitById(this.$route.params.id)
        .then(record => {
          this.record = record;
          this.record.BudgetSaldo = parseFloat(record.BudgetSaldo).toFixed(2);

          if (!this.record.NTR) {
            this.record.NTR = parseFloat(this.settingsStore.settings['Nachtragsprozent']).toFixed(2);
          }
          this.record.NTR = parseFloat(record.NTR).toFixed(2);
          document.title = this.record.Ordinal + ' ' + this.record.DisplayName + ' - ' + process.env.VUE_APP_NAME;
        })
        .catch(err => this.$showError(this, err.toString()))
        .finally(() => {
          this.$nextTick(() => {
            this.loading = false;
          });
          this.loading = false;
        });
    },
    updateSingleField() {
      if (!this.$refs.veForm.checkValidity()) {
        return this.$refs.veForm.reportValidity();
      }
      allocationUnitsService
        .updateAllocationUnit(this.record)
        .then(() =>
          this.$showSuccess(
            this,
            'Vergabeeinheit aktualisieren',
            'Vergabeeinheit "' + this.record.Ordinal + ' ' + this.record.DisplayName + '" erfolgreich aktualisiert.'
          )
        )
        .catch(err => this.$showError(this, 'Vergabeeinheit aktualisieren', err.toString()));
    },
    formatCurrency(number) {
      return this.$utils.numberToCurrency(number, settingsStore.settings['Centbetraege']);
    }
  },
  activated() {
    this.loading = true;
    this.refreshFormData();
    AppState.isLoading = false;
  },
  mounted() {
    const vm = this;
    // if a KKE/PAT was added/changed/deleted from budget table component, listen for the event to update the budget field
    this.$eventBus.$on('budget:changed', function(newValue) {
      vm.record.BudgetSaldo = newValue;
    });
  }
};
</script>

<style>
.input-group-sm .input-group-text {
  height: 29px !important;
  background-color: var(--bauvisor-light) !important;
  border-right: 0;
}
</style>
